import { once } from "es-toolkit/compat";
import { useRef } from "react";
import { sendUsage } from "utils/freemium";

export type UseBrushTeethResult = {
  // Idempotent: fires `sendUsage("brushTeeth")` once per VM lifetime —
  // called from the first `play` action. Stubbable via `di={{ useVm }}`.
  recordUsage: () => void;
};

export function useBrushTeeth(): UseBrushTeethResult {
  const ref = useRef<UseBrushTeethResult>();
  if (!ref.current) {
    ref.current = { recordUsage: once(() => sendUsage("brushTeeth")) };
  }
  return ref.current;
}
